// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__afLQS","errorLogs":"EditorFooter_errorLogs__3rOCx"};